import React, { useState } from 'react';

function StatusPicker({ label, value, onChange, options, id = 'general-picker', className = '', style = {} }) {
  const [state, setState] = useState(value || '');

  function handleChange(e) {
    setState(e.target.value);
    if (onChange) onChange(e.target.value);
  }

  return (
    <select
      id={id}
      value={state}
      onChange={handleChange}
      className={`h-[40px] shadow-sm border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${className}`}
      style={{ width: '150px', ...style }}
    >
      <option value="">{label}</option>
      {options.map(opt => (
        <option value={opt.value} key={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}

export default StatusPicker;